<script setup lang="ts">
import { Award } from '~~/server/api/corporation/profile'
import { SrcSet } from '~/composables/useSrcSet'

export interface AwardsListItemProps {
    award: Award
}

const props = defineProps<AwardsListItemProps>()

const imageSrc = computed((): SrcSet | undefined =>
    useSrcSet(props.award.image.path)
)
</script>

<template>
  <li class="awards-list-item col-6 col-sm-3">
    <article>
      <img
        :src="imageSrc?.src"
        :srcset="imageSrc?.srcSet"
        width="130"
        height="130"
        loading="lazy"
        decoding="async"
        :alt="props.award.title"
        class="h-auto mb-2"
      >
      <p class="fs-small text-center gamma">
        {{ props.award.title }}
      </p>
    </article>
  </li>
</template>

<style lang="scss" scoped>
@import './AwardsListItem.scss';
</style>
